import React from 'react';
import { useNavigate } from 'react-router-dom';
import { portal_url } from './App';
import './Terminal.css';

function Terminal() {
  const navigate = useNavigate();

  return (
    <>
      <div className="terminal-wrapper">
        <h1 className="terminal-title">Stormini Portal</h1>
        <div className="area-container">

          <div className="area-card arbeit" onClick={() => navigate("/tools/scanner3")}>
            <div className="area-content">
              <span className="material-symbols-outlined area-icon">business_center</span>
              <h2>BarcodeScanner</h2>
              <p>
                Jobwahl mit Drag & Drop
              </p>
            </div>
          </div>
          <div className="area-card freizeit" onClick={() => navigate("/jobs")}>
            <div className="area-content">
              <span className="material-symbols-outlined area-icon">tv</span>
              <h2>Job-Display</h2>
              <p>
                TV-Anzeige für Zuteilungen
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Terminal;
